import { render, staticRenderFns } from "./ClientPopup.vue?vue&type=template&id=20d34126&scoped=true"
import script from "./ClientPopup.vue?vue&type=script&lang=js"
export * from "./ClientPopup.vue?vue&type=script&lang=js"
import style0 from "./ClientPopup.vue?vue&type=style&index=0&id=20d34126&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d34126",
  null
  
)

export default component.exports